export default "__VITE_ASSET__Ck8_APlt__"